import Vue from "vue";
import Router from "vue-router";
import Index from "@views/home/Index";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Roots from "@views/roots/roots";
import rootsDetail from "@views/roots/rootsDetail";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/roots",
      name: "roots",
      meta: {
        title: "溯源",
        keepAlive: true,
        footer: true,
        home: false,
        backgroundColor: "#fff"
      },
      component: Roots
    },
    {
      path: "/rootsDetail",
      name: "rootsDetail",
      meta: {
        title: "溯源详情",
        keepAlive: true,
        footer: false,
        home: true,
        backgroundColor: "#fff"
      },
      component: rootsDetail
    },
    {
      path: "/index",
      name: "Index",
      meta: {
        title: "企业",
        keepAlive: true,
        footer: true,
        home: false,
        backgroundColor: "#fff"
      },
      component: Index
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "新闻",
        keepAlive: true,
        footer: true,
        home: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsList.vue")
    },
    {
      path: "/news_detail/:id",
      name: "NewsDetail",
      meta: {
        title: "新闻详情",
        keepAlive: true,
        home: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsDetail.vue")
    },
    {
      path: "/scanCode",
      name: "ScanCode",
      meta: {
        title: "扫码出库",
        keepAlive: true,
        footer: false,
        home: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/roots/scanCode.vue")
    },
    {
      path: "/login",
      name: "login",
      meta: {
        title: "登录",
        keepAlive: true,
        footer: false,
        home: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/roots/Login.vue")
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function() {
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  const { title, backgroundColor, footer, home, auth } = to.meta;
  console.log(to.name, form.name);
  if (auth === true && !$store.state.app.token) {
    if (form.name === "Login") return;
    return toLogin(true, to.fullPath);
  }
  document.title = title || process.env.VUE_APP_NAME || "crmeb商城";
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

export default router;
